import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=2c61f6ed&"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports